import type SearchStore from './schema/SearchStore';
import { createStore } from 'satcheljs';

const initialSearchStore: SearchStore = {
    searchNumber: 0,
    searchSessionGuid: null,
    conversationGuid: null,
    searchText: '',
    suggestionPill: null,
    staticFolderScopeId: null,
    previouslySelectedFolderId: null,
    suggestions: null,
    latestTraceId: null,
    isFetchingSuggestions: false,
    isSearchHistoryDirty: false,
    zeroQuerySuggestions: null,
};

export const getStore = createStore<SearchStore>('searchstore', initialSearchStore);

const searchStore = getStore();
export default searchStore;
